import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../../services/api";

const SetPaystackKeys = () => {
  const [secretKey, setSecretKey] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(true)
    api.admin.getPaystackApiKeys()
      .then((res) => {
        setSecretKey(res.data?.paystack_secret_key)
        setPublicKey(res.data?.paystack_public_key)
      })
      .catch((err) => {
        toast.error("Failed to get API keys.");
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!secretKey || !publicKey) {
      toast.error("Please provide both secret and public keys.");
      return;
    }
    setLoading(true);
    setIsFetching(true)

    const formData = new FormData();
    formData.append("secret_key", secretKey);
    formData.append("public_key", publicKey);

    api.admin.setPaystackApiKeys(formData)
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((err) => {
        console.error("Error updating API keys:", err);
      })
      .finally(() => {
        setLoading(false);
        setIsFetching(false);
      });
  };


  return (
    <div className="flex flex-col justify-center mt-[100px]">
      <div className="flex flex-col lg:flex-row gap-5 my-3">
        <Box
          fullWidth
          component="form"
          onSubmit={''}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "0 auto",
            padding: 2,
            boxShadow: 3,
            borderRadius: 1,
            backgroundColor: "white",
            maxWidth: 400,
            width: '100%'
          }}
        >
          <Typography variant="h5" sx={{ textAlign: 'center' }} component="h2" gutterBottom>
            Set Secret Key
          </Typography>
          {isFetching ? <CircularProgress /> : <TextField
            label="Secret Key"
            variant="outlined"
            name="secretkey"
            value={secretKey}
            onChange={(e) => setSecretKey(e.target.value)}
            fullWidth
            required
            sx={{ marginBottom: 2 }}
          />}
        </Box>
        <Box
          component="form"
          onSubmit={''}
          fullWidth
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "0 auto",
            padding: 2,
            boxShadow: 3,
            borderRadius: 1,
            backgroundColor: "white",
            maxWidth: 400,
            width: '100%'
          }}
        >
          <Typography variant="h5" sx={{ textAlign: 'center' }} component="h2" gutterBottom>
            Set Public Key
          </Typography>
          {isFetching ? <CircularProgress /> : <TextField
            label="Public key"
            variant="outlined"
            name="publickey"
            value={publicKey}
            onChange={(e) => setPublicKey(e.target.value)}
            fullWidth
            required
            sx={{ marginBottom: 2 }}
          />}
        </Box>
      </div>
      <div className="m-auto">
        <Button type="submit" variant="contained" color="primary" disabled={loading} onClick={handleSubmit}>
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default SetPaystackKeys